"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.renderDateWithTime = renderDateWithTime;
exports.renderDateWithoutTime = renderDateWithoutTime;
exports.renderPopoverDate = renderPopoverDate;
exports.renderDateCalendar = renderDateCalendar;
exports.renderDateCalendarWithTime = renderDateCalendarWithTime;
exports.renderDateCalendarWithoutTime = renderDateCalendarWithoutTime;
exports.renderPopoverDateCalendar = renderPopoverDateCalendar;
exports.renderDateWithTimeTwelveHourPeriod = renderDateWithTimeTwelveHourPeriod;
exports.renderDateFromNow = renderDateFromNow;
exports.renderPopoverDateFromNow = renderPopoverDateFromNow;
exports.updateCmsEditorBeforeSave = updateCmsEditorBeforeSave;
exports.getStudyArmLabelFromId = getStudyArmLabelFromId;
exports.camelCaseToSentenceCase = camelCaseToSentenceCase;
exports.isBlank = isBlank;

require("antd/es/popover/style/css");

var _popover = _interopRequireDefault(require("antd/es/popover"));

var React = _interopRequireWildcard(require("react"));

var _lodash = require("lodash");

var _moment = _interopRequireDefault(require("moment"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function renderDateWithTime(date) {
  return date ? (0, _moment.default)(date).format('YYYY-MM-DD h:mm:ss a') : 'N/A';
}

function renderDateWithoutTime(date) {
  return date ? (0, _moment.default)(date).format('YYYY-MM-DD') : 'N/A';
}

function renderPopoverDate(date) {
  return /*#__PURE__*/React.createElement(_popover.default, {
    content: renderDateWithTime(date)
  }, renderDateWithoutTime(date));
}

function renderDateCalendar(date) {
  return date ? (0, _moment.default)(date).local().calendar() : 'N/A';
}

function renderDateCalendarWithTime(date) {
  return (0, _moment.default)(date).local().calendar(null, {
    sameElse: 'DD/MM/YYYY [at] HH:mm A'
  });
}

function renderDateCalendarWithoutTime(date) {
  return (0, _moment.default)(date).local().calendar(null, {
    sameDay: 'dddd, MMMM Do',
    nextDay: 'dddd, MMMM Do',
    nextWeek: 'dddd, MMMM Do',
    lastDay: 'dddd, MMMM Do',
    lastWeek: 'dddd, MMMM Do',
    sameElse: 'dddd, MMMM Do'
  });
}

function renderPopoverDateCalendar(date) {
  return /*#__PURE__*/React.createElement(_popover.default, {
    content: renderDateWithTime(date)
  }, renderDateCalendar(date));
}

function renderDateWithTimeTwelveHourPeriod(date) {
  return date ? (0, _moment.default)(date).format('YYYY-MM-DD hh:mma') : 'N/A';
}

function renderDateFromNow(date) {
  return (0, _moment.default)(date).fromNow();
}

function renderPopoverDateFromNow(date) {
  return /*#__PURE__*/React.createElement(_popover.default, {
    content: renderDateWithTime(date)
  }, renderDateFromNow(date));
}
/**
 * Adjusts body text before it is saved to database
 * @param body String for the editor content
 */


function updateCmsEditorBeforeSave(body) {
  if (body) {
    const updatedBody = body.replace(/hmp%3A/g, 'hmp:');
    return updatedBody;
  }

  return body;
}

function getStudyArmLabelFromId(studyArms, studyArmId) {
  if (!studyArms) return '';

  const studyArm = _lodash._.find(studyArms, sa => sa.id == studyArmId);

  return studyArm.name;
}

function camelCaseToSentenceCase(str) {
  if (!str) return '';
  const result = str.replace(/([A-Z])/g, ' $1');
  const finalResult = result.charAt(0).toUpperCase() + result.slice(1);
  return finalResult;
}

function isBlank(value) {
  return !value || value.trim().length === 0;
}